export default "__VITE_ASSET__Ckh0WnCA__"